import './ServicesPage.css';

function ServicesPage() { 
  return (
    <>
    <div className="Head">
        <h1>Our Services</h1>
        <p>Comprehensive aluminium solutions designed to enhance your property's functionality, security, and aesthetic appeal.</p>
      </div>

      <div className='Title'>
        <h1>What We Offer</h1>
        <p>Professional aluminium solutions tailored to your needs. From custom design to installation and maintenance, we deliver excellence at every step.</p>
      </div>

      <section className="justASection">
      <div className="card-section"> 

        <div className='Card'>
          <img src='../assets/home.png' alt="Custom aluminium installation service"/>
          <h6>Custom Design & Installtion</h6>
          <p>Bespoke aluminium doors and windows designed to your exact specifications. Our expert team handles everything from initial consultation to final installation, ensuring perfect fit and finish for your property.</p>
        </div>

        <div className='Card'>
          <img src='../assets/Onsite.png' alt="Onsite consultation service"/>
          <h6>Custom Onsite Consultations</h6>
          <p>Professional site visits to assess your needs, take accurate measurements, and provide expert advice. We'll discuss design options, material choices, and provide detailed quotes at no obligation.</p>
        </div>

       <div className='Card'>
          <img src='../assets/settings.png' alt="Aluminium repair service"/>
          <h6>Repairs & Replacements</h6>
          <p>Comprehensive repair services for existing aluminium installations. From weather seal replacements to complete window upgrades, we restore your aluminium features to peak performance.</p>
        </div>

        <div className='Card'>
            <img src='../assets/building.png' alt="Commercial aluminium project"/>
            <h6>Commercial Projects</h6>
            <p>Large-scale aluminium solutions for commercial buildings, office complexes, and industrial facilities. We handle projects of any size with specialized equipment and experienced project management.</p>
          </div>

       </div>
      </section>


      <div className='Title'>
        <h2>Why Choose WIP Aluminium Works?</h2>
        <p>We combine years of expertise with cutting-edge materials and customer-focused service to deliver exceptional results.</p>
      </div>


      <section className='Whysection'>
        <div className='WHYUS'>         

        <div className='Why'>
          <img src='../assets/home.png' alt="Expert aluminium craftsmanship"/>
          <h6>Expert Craftsmanship</h6>
          <p>Over 15 years of experience with certified artisans ensuring premium quality workmanship on every project.</p>
        </div>

        <div className='Why'>
          <img src='../assets/Onsite.png' alt="Fast aluminium installation"/>
          <h6>Quick Turnaround</h6>
          <p>Efficient project management and streamlined processes deliver your aluminium solutions on time, every time.</p>
        </div>

       <div className='Why'>
          <img src='../assets/settings.png' alt="SABS compliant aluminium materials"/>
          <h6>SABS-Compliant Materials</h6>
          <p>All materials meet South African Bureau of Standards requirements, ensuring safety, durability, and compliance.</p>
        </div>

        <div className='Why'>
            <img src='../assets/building.png' alt="Warranty on aluminium installations"/>
            <h6>Comprehensive Warranty</h6>
            <p>Industry-leading warranties on all installations with ongoing support and maintenance services available.</p>
        </div>

        </div>
      </section>

    </>
  );
}

export default ServicesPage;
